import { Component, Input, OnInit } from "@angular/core";
import { takeRight } from "lodash";
import * as Highcharts from "highcharts";

@Component({
  selector: "line",
  templateUrl: "./line.component.html",
  styleUrls: ["./line.component.scss"],
})
export class LineComponent implements OnInit {
  options: Object;
  toolTipText: string;
  toolTipTitle: string;
  Highcharts = Highcharts;
  @Input()
  chartData;
  @Input()
  categories;
  @Input()
  goal;
  @Input()
  goalText;
  @Input()
  dataSuffix;
  @Input()
  dataPrefix;
  @Input()
  min;
  @Input()
  max;
  @Input()
  subTitle;
  @Input()
  entityLevel;
  @Input()
  studentFirstName;
  @Input()
  level;
  @Input()
  roundTo = 0;
  @Input()
  periodicity;

  constructor() {}

  ngOnInit() {
    if (
      this.periodicity == "ongoing" ||
      this.periodicity == "periodic" ||
      this.periodicity == "monthly"
    ) {
      // show last two years of data for ongoing and periodic metrics
      this.chartData = takeRight(this.chartData, 2);
    } else if (
      this.periodicity == "annual" &&
      this.chartData &&
      this.chartData[0] &&
      this.chartData[0].data
    ) {
      // show last three years of data for annual metrics
      this.chartData[0] = {
        ...this.chartData[0],
        data: takeRight(this.chartData[0].data, 3),
      };
    }
    this.createChart();
  }

  createChart() {
    var self = this;
    this.options = {
      chart: {
        spacingRight: this.goal != null ? 35 : 0,
      },
      xAxis: {
        type: "category",
        categories: this.categories,
        tickmarkPlacement: "on",
        tickPosition: "outside",
        tickColor: "#929292",
        tickWidth: 0.75,
        lineColor: "#929292",
        lineWidth: 0.75,
        startOnTick: true,
        labels: {
          formatter: function () {
            return (
              '<span style="fill: #929292; text-overflow: none">' +
              this.value +
              "</span>"
            );
          },
        },
      },
      yAxis: {
        min: Math.floor(this.min),
        max: Math.ceil(this.max),
        gridLineWidth: 0,
        labels: {
          enabled: false,
        },
        title: {
          text: null,
        },
        plotLines:
          this.goal != null
            ? [
                {
                  color: "#878787",
                  dashStyle: "dash",
                  value: this.goal,
                  width: 2,
                  zIndex: 4,
                  label: {
                    text:
                      this.goalText +
                      (this.level == "school"
                        ? "<br/>SCHOOL<br/>GOAL"
                        : "<br/>GOAL"),
                    rotation: 0,
                    style: {
                      color: "#878787",
                    },
                    align: "right",
                    x: 40,
                  },
                },
              ]
            : [],
      },
      title: { text: null },
      series: this.chartData,
      credits: false,
      plotOptions: {
        line: {
          marker: {
            symbol: "circle",
          },
          lineWidth: 1.5,
        },
        series: {
          label: {
            enabled: false,
          },
          animation: false,
        },
      },
      legend: {
        enabled: this.chartData[0].name === " " ? false : true,
        layout: "horizontal",
        align: "center",
        verticalAlign: "bottom",
        itemStyle: {
          width: "100px",
          fontWeight: 400,
          fontSize: "10px",
        },
      },
      tooltip: {
        shared: false,
        useHTML: true,
        borderColor: "#aaa",
        backgroundColor: "rgba(255, 255, 255, 1.0)",
        shadow: false,
        headerFormat: "",
        style: {
          fontFamily: "'Lato', Helvetica, sans-serif",
          backgroundColor: "#FFFFFF",
        },
        formatter: function () {
          if (self.entityLevel !== "student" && self.entityLevel !== "usage") {
            if (self.dataSuffix === "") {
              self.toolTipText = `${self.dataPrefix || ""}<strong>${
                this.point.numerator != null
                  ? this.point.numerator.toLocaleString()
                  : ""
              }</strong> ${this.point.descriptor}`;
            } else {
              self.toolTipText = `${self.dataPrefix || ""}<strong>${
                this.point.numerator != null
                  ? this.point.numerator.toLocaleString()
                  : ""
              }</strong> of
                  ${self.dataPrefix || ""}<strong>${
                this.point.denominator != null
                  ? this.point.denominator.toLocaleString()
                  : ""
              }</strong> ${this.point.descriptor}`;
            }
          } else {
            if (
              this.point.name == "1 month ago" ||
              this.point.name == "2 months ago" ||
              this.point.name == "3 months ago"
            ) {
              self.toolTipText = `${self.dataPrefix || ""}<strong>${
                this.point.numerator
              }</strong> out of
                  ${self.dataPrefix || ""}<strong>${
                this.point.denominator
              }</strong> ${this.point.descriptor}
                  ${this.point.name}`;
            } else if (this.point.name == "Current") {
              self.toolTipText = `${self.dataPrefix || ""}<strong>${
                this.point.numerator
              }</strong> out of
                ${self.dataPrefix || ""}<strong>${
                this.point.denominator
              }</strong> ${this.point.descriptor} in the current month`;
            } else {
              self.toolTipText = `${self.dataPrefix || ""}<strong>${
                this.point.numerator
              }</strong> out of
                  ${self.dataPrefix || ""}<strong>${
                this.point.denominator
              }</strong> ${this.point.descriptor} in
                  ${this.point.name} ${this.point.schoolYear}`;
            }
          }
          if (self.entityLevel !== "usage") {
            self.toolTipTitle = `${this.point.name} ${this.series.name}`;
          } else {
            self.toolTipTitle = `${this.point.name} ${this.point.schoolYear}`;
          }
          return (
            `<div>
                      <span class="metric-tooltip title capitalize tile_body">${self.toolTipTitle}</span>
                      <span class="metric-tooltip value tooltip_value" style="color:${this.point.color}">` +
            (this.point.alphaValue
              ? this.point.alphaValue
              : `${self.dataPrefix || ""}${
                  this.point.y != null
                    ? this.point.y.toLocaleString(undefined, {
                        minimumFractionDigits: self.roundTo,
                        maximumFractionDigits: self.roundTo,
                      })
                    : ""
                }<!--
                              -->${self.dataSuffix}`) +
            `</span>
                    </div>
                    <div class="metric-tooltip description body_tooltip_text">${self.toolTipText}</div>`
          );
        },
      },
    };
  }

  //KPI-9385 - Added call to the force the chart to resize itself after a digest cycle.  This is needed in cases when the renderTo
  //container changes size, but the chart has already set its size.
  chartCallback = (chart) => {
    setTimeout(() => {
      if (chart.chartHeight !== chart.renderTo.clientHeight) {
        chart.setSize(undefined, null, true);
      }
    });
  };
}
